import React, { useEffect, useState } from "react";
import { Eye } from "lucide-react";
import { familiaApi, getHijoActivo, setHijoActivo, isParentAccount } from "../lib/api";

// Barra de "vista de acompañamiento" para cuentas de Padres y Madres.
// Permite elegir al hijo/a activo; todos los módulos muestran su progreso (solo lectura).
export function ParentViewBar() {
  const [hijos, setHijos] = useState([]);
  const [active, setActive] = useState(getHijoActivo());

  useEffect(() => {
    if (!isParentAccount()) return;
    familiaApi.misHijos().then((r) => {
      const list = r.hijos || [];
      setHijos(list);
      const cur = getHijoActivo();
      const valid = list.find((h) => h.id === cur);
      if (!valid && list.length) {
        setHijoActivo(list[0].id);
        setActive(list[0].id);
        window.location.reload();
      }
    }).catch(() => {});
    // eslint-disable-next-line
  }, []);

  if (!isParentAccount() || hijos.length === 0) return null;

  const change = (id) => {
    if (id === active) return;
    setHijoActivo(id);
    setActive(id);
    window.location.reload();
  };
  const activeName = (hijos.find((h) => h.id === active) || {}).nombre || "tu hijo/a";

  return (
    <div data-testid="parent-view-bar" className="mb-6 rounded-2xl bg-[#0A1C30] text-white p-4 flex flex-col sm:flex-row sm:items-center gap-3">
      <div className="flex items-center gap-2 flex-1">
        <Eye className="w-5 h-5 text-[var(--gold)] flex-shrink-0" />
        <p className="text-sm font-bold leading-snug">
          Vista de acompañamiento — estás viendo el progreso de{" "}
          <span className="text-[var(--gold)]">{activeName}</span>{" "}
          <span className="font-normal text-white/60">(solo lectura)</span>
        </p>
      </div>
      {hijos.length > 1 && (
        <div className="flex flex-wrap gap-2">
          {hijos.map((h) => (
            <button
              key={h.id}
              data-testid={`parent-view-hijo-${h.id}`}
              onClick={() => change(h.id)}
              className={`text-xs font-bold px-3 py-1.5 rounded-full transition-colors ${active === h.id ? "bg-[var(--gold)] text-[#0A1C30]" : "bg-white/10 text-white hover:bg-white/20"}`}
            >
              {h.nombre}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
